/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Nav_Eventreport1Inputs */

const ja_playdata_nav_eventreport1 = /** @type {(inputs: Playdata_Nav_Eventreport1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eスポーツイベントレポート`)
};

const en_playdata_nav_eventreport1 = /** @type {(inputs: Playdata_Nav_Eventreport1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esports Event Report`)
};

/**
* | output |
* | --- |
* | "Esports Event Report" |
*
* @param {Playdata_Nav_Eventreport1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const playdata_nav_eventreport1 = /** @type {((inputs?: Playdata_Nav_Eventreport1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Nav_Eventreport1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_nav_eventreport1(inputs)
	return en_playdata_nav_eventreport1(inputs)
});
export { playdata_nav_eventreport1 as "playdata_nav_eventReport" }